(() => {
  const bootstrap = document.getElementById('socialez-js-carrousel');
  const widget = bootstrap?.closest('.custom-html')?.querySelector('.socialez-carrousel-widget');
  if (!bootstrap || !widget) return;

  let started = false;
  let observer;
  const load = () => {
    if (started) return;
    started = true;
    observer?.disconnect();
    window.removeEventListener('beforeprint', load);
    const script = document.createElement('script');
    for (const attribute of bootstrap.attributes) {
      script.setAttribute(attribute.name, attribute.value);
    }
    script.src = 'https://deg3xyi07y58.cloudfront.net/widget_script_fixe_carrousel.js';
    script.async = true;
    bootstrap.replaceWith(script);
  };

  if (!('IntersectionObserver' in window)) {
    load();
    return;
  }
  observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting)) load();
  }, { rootMargin: '500px 0px' });
  observer.observe(widget);
  window.addEventListener('beforeprint', load, { once: true });
})();
